/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Text as NBText } from 'native-base';

import { ITextProps } from './types';

export const Text = ({ ...props }: ITextProps) => <NBText {...props} />;
